module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryi"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryi"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter02"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryi"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter03"
    }
  }, [_c('em', [_vm._v("Note on Film Titles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 1 TOWARD A PERFORMATIVE THEORY OF EURO HORROR CINEMA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("1 Academic Hot Spots and Blind Spots:"), _c('br'), _vm._v("Horror Film Studies and Euro Horror Cinema")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Fast, Cheap, and Out of Control:"), _c('br'), _vm._v("The Academic Case against Euro Horror Cinema")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Playing Dead, Take One:"), _c('br'), _vm._v("Euro Horror Film Production")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Playing Dead, Take Two:"), _c('br'), _vm._v("Euro Horror Film Reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Return of the Repressed:"), _c('br'), _vm._v("Euro Horror Cinema in Contemporary American Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART 2 CASE STUDIES IN EURO HORROR CINEMA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Blood and Black Lace:"), _c('br'), _vm._v("The "), _c('em', [_vm._v("Giallo")]), _vm._v(" Film")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The Whip and the Body:"), _c('br'), _vm._v("The S&M Horror Film")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Cannibal Apocalypse:"), _c('br'), _vm._v("Cannibal and Zombie Films")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONCLUSION")]), _vm._v(" From the Grindhouse to the Arthouse: The Legacy of Euro Horror Cinema")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryi"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Works Cited")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entryi"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0